import { Link } from '@chakra-ui/next-js';
import { Box, Flex, Text } from '@chakra-ui/react';

export interface Post {
  id: string;
  title: string;
  description: string;
  slug: string;
  createdAt: string;
  readingMinutes?: number;
}

interface CardProps {
  post: Post;
}

export function Card({ post }: CardProps) {
  return (
    <Link
      href={`/posts/${post.slug}`}
      role="group"
      display="block"
      py={{ base: '20px', md: '24px' }}
      borderBottomWidth="1px"
      borderColor="line.subtle"
      _last={{ borderBottomWidth: '0px' }}
      _hover={{ borderColor: 'accent.line', textDecoration: 'none' }}
      transition="border-color 0.25s ease"
    >
      <Flex
        gap="14px"
        align="center"
        mb="8px"
        fontFamily="mono"
        fontSize="11px"
        letterSpacing="0.12em"
        textTransform="uppercase"
        color="text.faint"
      >
        <Text as="time">{post.createdAt}</Text>
        {post.readingMinutes && (
          <>
            <Box w="3px" h="3px" bg="text.faint" borderRadius="full" />
            <Text>{post.readingMinutes} min</Text>
          </>
        )}
      </Flex>

      <Text
        fontFamily="display"
        fontSize={{ base: '28px', md: '32px' }}
        lineHeight="1.1"
        color="text.primary"
        _groupHover={{ color: 'accent.500' }}
        transition="color 0.25s ease"
      >
        {post.title}
      </Text>

      <Text
        mt="8px"
        fontSize="15px"
        color="text.muted"
        maxW="60ch"
        noOfLines={2}
      >
        {post.description}
      </Text>
    </Link>
  );
}
